module.exports = __webpack_public_path__ + "img/search-location.67719b92.svg";